import FilterByTopic from './FilterByTopic'

export default FilterByTopic
